import _ from 'underscore';

import { TrelloMarkdown } from '@trello/markdown';
import { createNewIndex } from '@trello/search';

import type { Plugins } from './types';

export const createSearchIndex = (plugins: Plugins) => {
  const markdown = new TrelloMarkdown();

  // Power-Up directory search logic.
  // 1. We use 3 indexes (name, overview, desc) to display results for, in that order
  // 2. We randomize the order of the input plugins so the results alphabetical

  const nameIndex = createNewIndex();
  const overviewIndex = createNewIndex();
  const descriptionIndex = createNewIndex();

  const shuffledPlugins = _.shuffle<Plugins>(plugins);

  shuffledPlugins.forEach((plugin) => {
    if (!plugin.listing) {
      return;
    }
    if (plugin.listing.name) {
      nameIndex.add(plugin.id, plugin.listing.name);
    }
    if (plugin.listing.overview) {
      overviewIndex.add(
        plugin.id,
        markdown.text(plugin.listing.overview).output,
      );
    }
    if (plugin.listing.description) {
      descriptionIndex.add(
        plugin.id,
        markdown.text(plugin.listing.description).output,
      );
    }
  });

  return {
    search(query: string) {
      const nameResults = nameIndex.search(query, 20) as string[];
      const overviewResults = overviewIndex.search(query, 15) as string[];
      const descriptionResults = descriptionIndex.search(query, 10) as string[];

      const combinedResults = nameResults.concat(
        overviewResults,
        descriptionResults,
      );
      return _.uniq(combinedResults)
        .map((idPlugin: string) =>
          plugins.find((plugin) => plugin.id === idPlugin),
        )
        .filter(<T>(plugin?: T): plugin is T => Boolean(plugin));
    },
  };
};

export const SearchHelper = {
  createSearchIndex,
};
